import { render, staticRenderFns } from "./KnowledgeTool.vue?vue&type=template&id=eeb6374e&scoped=true"
import script from "./KnowledgeTool.vue?vue&type=script&lang=js"
export * from "./KnowledgeTool.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeTool.vue?vue&type=style&index=0&id=eeb6374e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb6374e",
  null
  
)

export default component.exports